

const WorkWithUs = () => {
  return (
    <>
      <main className="container mx-auto">
        <div className="text-md text-gray-500 font-bold py-8 px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-5xl  font-bold text-teal-500">
              WORK WITH US
            </h2>
            <p className="mt-2 text-2xl font-bold text-gray-500">
              Collaborate as a Trusted Partner in Cloud Innovation
            </p>
            <hr className="border-teal-400 border-[1.5px] dark:border-gray-700 "></hr>
            <div className="mt-8">
              <h3 className="text-3xl font-bold text-teal-500">
                Embrace a Network of Expertise
              </h3>
              <p className="mt-2">
                Cloudifiers, an essential service under MK Consultancy (UK) Ltd,
                invites independent cloud professionals to join our expansive
                network of consultants. We are a hub of innovation, drawing on
                the diverse strengths of skilled contractors to deliver bespoke
                AWS solutions to our clients.
              </p>
            </div>
            <div className="mt-8">
              <h3 className="text-3xl font-bold text-teal-500">
                Project-Based Opportunities
              </h3>
              <p className="mt-2 ">
                Our model is built on flexibility and expertise. We collaborate
                with contractors on a project-by-project basis, providing the
                freedom to work autonomously and the opportunity to engage with
                stimulating challenges that match your skill set. When a new
                project aligns with your expertise, we’ll reach out to integrate
                you into our dedicated team for the duration of the assignment.
              </p>
            </div>
            <div className="mt-8">
              <h3 className="text-3xl font-bold text-teal-500">
                What We Offer
              </h3>
              <ul className="mt-2  font-bold list-disc list-inside mb-6">
                <li>Competitive contract-based compensation</li>
                <li>Dynamic projects with a diverse clientele</li>
                <li>
                  The opportunity to work with a team of seasoned AWS experts
                </li>
                <li>
                  A professional network that supports growth and knowledge
                  sharing
                </li>
              </ul>
            </div>
            <div className="mt-8">
              <h3 className="text-3xl font-bold text-teal-500">
                Seeking Cloud Enthusiasts
              </h3>
              <p className="mt-2">
                Are you an independent consultant with a passion for cloud
                solutions? Do you have AWS certifications that validate your
                expertise? We are looking for individuals who:
              </p>
              <ul className="mt-2  font-bold list-disc list-inside  mb-6">
                <li>Excel in delivering AWS cloud services.</li>
                <li>Thrive in a project-based, consultative environment.</li>
                <li>
                  Are eager to collaborate on varied assignments with a focus on
                  delivering excellence.
                </li>
              </ul>
              <h3 className="mt-8 text-3xl font-bold text-teal-500">
                Connect With Us
              </h3>
              <p className="mt-2">
                If you are a self-motivated consultant keen on shaping the
                future of cloud services, we want to hear from you. Joining our
                network means becoming part of an innovative community that
                values your independence and expertise.
              </p>
              <h3 className="mt-8 text-3xl font-bold text-teal-500">
                Engage With Us
              </h3>
              <p className="mt-2">
                To express interest in future collaborations, please send us
                your professional profile, areas of expertise, and a portfolio
                of your work. When projects arise that call for your unique
                skills, you’ll be the first we call.
              </p>
              <p className="mt-4">
                Join us at Cloudifiers, where together we can drive the cloud
                revolution, one project at a time.
              </p>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default WorkWithUs

